module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Hapus Piutang ")]), _vm._v(" "), _c('Button-group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receivables.length > 0 && _vm.accessRole),
      expression: "receivables.length > 0 && accessRole"
    }],
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "error",
      "icon": "trash-b",
      "size": "small"
    },
    on: {
      "click": _vm.showDeleteAll
    }
  }, [_c('span', [_vm._v("Delete All")])])], 1), _vm._v(" "), _c('Button-group', {
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSearch,
      "icon": "ios-search",
      "size": "small"
    },
    on: {
      "click": _vm.getReceivables
    }
  }, [(!_vm.loadingSearch) ? _c('span', [_vm._v("Search")]) : _c('span', [_vm._v("Wait.....")])])], 1), _vm._v(" "), _c('Table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receivables.length > 0),
      expression: "receivables.length > 0"
    }],
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.receivables,
      "no-data-text": ""
    },
    on: {
      "on-row-click": _vm.showDeleteReceivable
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    on: {
      "on-cancel": function($event) {
        _vm.confirmMarkingheadercode = ''
      }
    },
    model: {
      value: (_vm.modalConfirmDelete),
      callback: function($$v) {
        _vm.modalConfirmDelete = $$v
      },
      expression: "modalConfirmDelete"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Konfirmasi")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.receivableToDelete.markingheadercode) + " : " + _vm._s(_vm.receivableToDelete.transactionDate))]), _vm._v(" "), _c('p', [_vm._v("Keterangan : "), _c('br'), _vm._v(_vm._s(_vm.receivableToDelete.description))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Debit Amount : Rp "), _c('b', [_vm._v(_vm._s(_vm.receivableToDelete.debitAmount) + " ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v(" Ketik "), _c('b', [_vm._v(_vm._s(_vm.receivableToDelete.markingheadercode))]), _vm._v(" untuk Lanjut")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Input', {
    model: {
      value: (_vm.confirmMarkingheadercode),
      callback: function($$v) {
        _vm.confirmMarkingheadercode = $$v
      },
      expression: "confirmMarkingheadercode"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.receivableToDelete.markingheadercode == _vm.confirmMarkingheadercode.toUpperCase()),
      expression: "receivableToDelete.markingheadercode == confirmMarkingheadercode.toUpperCase()"
    }],
    attrs: {
      "type": "error",
      "size": "large",
      "long": ""
    },
    on: {
      "click": _vm.deleteReceivable
    }
  }, [_vm._v("Hapus\n                ")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47ce30b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/receivable/ReceivableDelete.vue
// module id = 1801
// module chunks = 1